<template>
  <div class="idea-challenges">
    <PreContentHeader :show-loading="!contentReady" :error-message="contentLoadError"></PreContentHeader>
    <transition name="fade">
      <div v-if="contentReady && contentLoadError === ''">
        <ContentHeader :name="award.title.rendered"></ContentHeader>
        <!-- <ContentHeader name="EMPLOYEE RECOGNITION"></ContentHeader> -->
        <section>
          <div class="card mb-3">
            <div v-if="award._embedded['wp:featuredmedia'] !== undefined" class="featuredImg">
              <img v-if="award._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url"
                :src="award._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url"
                :alt="award._embedded['wp:featuredmedia'][0].alt_text"
                :title="award._embedded['wp:featuredmedia'][0].title.rendered"
              >
            </div>
            <div v-html="award.content.rendered" class="card-body px-3 pb-0"></div>
            <div v-if="award.nomination_event_time_frame.length > 0">
              <ul class="fa-ul" v-if="award.nomination_event_time_frame[0][0][0].nomination_event_date_from !== ''">
                <li class="h6">
                  <span class="fa-li"><i class="fas fa-calendar-alt fa-fw fa-sm text-black-50"></i></span>
                  {{award.nomination_event_time_frame[0][0][0].nomination_event_date_from}} -
                  {{award.nomination_event_time_frame[0][0][0].nomination_event_date_to}}
                </li>
              </ul>
            </div>
            <!-- <ChildNominationEventsList v-if="award.child_nomination_awards.length > 0 && award.child_nomination_awards[0] !== []" class="px-3 pb-3" :awards="award.child_nomination_awards[0][0]" name="The awards categories are:"></ChildNominationEventsList> -->
            <div v-if="madeNomination" class="px-3 pb-3">
              <div class="alert alert-success" role="alert">
                Congratulations, you've nominated:
                <ul>
                  <li>
                    <strong>{{validatedNominee.name}}</strong> from {{validatedNominee.country}} -
                    Employee number: <strong>{{validatedNominee.employeeNum}}</strong><br>
                    Department: <strong>{{validatedNominee.department}}</strong><br>
                    Company: <strong>{{validatedNominee.company}}</strong><br>
                  </li>
                </ul>
              </div>
              <button type="button" name="button" class="btn btn-primary" v-on:click="removeNominee()">Nominate someone else</button>
            </div>
            <div v-if="award.include_nomination_form[0] === 'Yes' && award.nomination_fields.length > 0 && !madeNomination" class="px-3 pb-3">
              <form v-on:submit.prevent=""><!-- Added OnSubmit; after few plugins update issues -->
                <div class="input-group input-group-lg mb-4">
                  <vue-bootstrap-typeahead class="form-control" v-model="nominatedPerson" :data="nomineesList" @keydown.enter="search" :serializer="item => item.email" placeholder="Search by email address, seperate multiple email by comma..." prepend="" ></vue-bootstrap-typeahead>
                  <div class="input-group-append">
                    <button class="btn btn-primary" type="submit" :disabled="nominatedPerson.length === 0" v-on:click="setNominee()">{{NominationButtonText}}</button>
                  </div>
                </div>
              </form>
              <PreContentHeader :show-loading="searchingForEmployee" :error-message="searchingForEmployeeError"></PreContentHeader>
              <transition name="grow">
                <div v-if="showNominationForm">
                  <hr>
                  <strong>You are nominating:</strong><br>
                  <div>
                    <ul>
                      <li>
                        <strong>{{validatedNominee.name}}</strong> from {{validatedNominee.country}} -
                        Employee number: <strong>{{validatedNominee.employeeNum}}</strong><br>
                        Department: <strong>{{validatedNominee.department}}</strong><br>
                        Company: <strong>{{validatedNominee.company}}</strong><br>
                      </li>
                    </ul>
                  </div>
                  <hr>
                  <form v-on:submit.prevent=""><!-- Added OnSubmit; after few plugins update issues -->
                    <div v-for="formField in nominationFields" v-bind:key="formField.index">
                      <NominationField
                        :type="formField.type"
                        :description="formField.description"
                        :secondary-description="formField.secondaryDescription"
                        :description-lvl-two="formField.description_lvl_two"
                        :secondary-description-lvl-two="formField.secondary_description_lvl_two"
                        :isRequired="formField.isRequired"
                        :checkbox-labels="formField.checkboxLabels"
                        v-on:updatedFieldContent="fieldUpdated($event)"
                        :validationMethod="formField.validationMethod"
                        :displayField="formField.display_field"
                        :errorClass="formField.errorClass">
                      </NominationField>
                    </div>
                    <div class="row pt-2 mb-4">
                      <div class="col offset-md-4 offset-lg-4 offset-xl-3" v-if="submitClicked">
                        <button @click="submitNomination" type="submit" class="btn btn-primary btn-lg">Submit Nomination</button>
                      </div>
                    </div>
                  </form>
                </div>
              </transition>
              <PreContentHeader :show-loading="creatingNomination" :error-message="createNominationError"></PreContentHeader>
            </div>
          </div>
        </section>
        <div v-if="award.additional_content.length > 0 && award.additional_content[0] !== '' && award.additional_content !== ''" class="card mb-3">
          <div class="card-body" v-html="award.additional_content[0]"></div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import ContentHeader from '@/components/ContentHeader'
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import WordpressRestURI from '@/helpers/WordpressRestURI.js'
import ADauthentication from '@/helpers/ADauthentication.js'
import NominationNotification from '@/helpers/NominationNotification.js'
import ChildNominationEventsList from '@/components/ChildNominationEventsList'
import NominationField from '@/components/NominationField'
import Loading from '@/components/Loading'
import PreContentHeader from '@/components/PreContentHeader'
import vueBootstrapTypeahead from 'vue-bootstrap-typeahead'
export default {
  data () {
    return {
      award: [],
      errors: [],
      contentReady: false,
      contentLoadError: '',
      nominationContent: [],
      nominationFields: [],
      nominatedPerson: '',
      madeNomination: false,
      validatedNominee: '',
      showNominationForm: false,
      creatingNomination: false,
      createNominationError: '',
      searchingForEmployee: false,
      searchingForEmployeeError: '',
      isContractorErrorSet: true,
      submitClicked: true,
      NominationButtonText: 'Nominate',
      NominationPlaceholder: 'Search by name and surname or email address...',
      NominationTeamsContent: [],
      query: '',
      nomineesList: [],
      employeeHierarchy: {}
    }
  },
  components: {
    PreContentHeader,
    ContentHeader,
    ChildNominationEventsList,
    NominationField,
    Loading,
    vueBootstrapTypeahead
  },
  methods: {
    setValidatedNominee: function (userData) {
      if (this.checkForDuplicateNominee(userData)) {
        console.log('UD EH', userData.employeehierarchy)
        this.validatedNominee = {
          name: userData.firstname + ' ' + userData.lastname,
          slug: userData.email.replace(/\./g, '-').replace(/@/g, '').toLowerCase(),
          department: userData.department,
          company: (userData.company === '') ? 'Multichoice' : userData.company,
          employeeNum: userData.employeenumber,
          country: userData.country,
          email: userData.UPN,
          emailToNotify: userData.email,
          lineManagerName: (!userData.managername) ? userData.employeehierarchy['line-manager-name'] : userData.managername,
          lineManagerEmail: (!userData.manageremail) ? userData.employeehierarchy['line-manager-email'] : userData.manageremail,
          employeeHierarchy: userData.employeehierarchy
        }
        this.setNominationContent(this.award.nomination_fields[0][0])
      }
    },
    validateContractors: function () {
      if (this.$route.params.name !== 'employee-of-the-year-2018') {
        if (this.validatedNominee.employeeNum === 0 || this.validatedNominee.employeeNum === '0') {
          this.isContractorErrorSet = false
          this.showNominationForm = false
          this.searchingForEmployee = false
          this.searchingForEmployeeError = 'User names: ' + this.nominatedPerson + ' is a contractor and could not be nominated'
          throw new TypeError(this.searchingForEmployeeError)
        }
      }
    },
    setMonetaryField() { 
      if ( this.validatedNominee.name ) {
        if ( confirm("Moving to monetary nomination will reset the behaviour. \n Please confirm.") === true ) {
          this.setNominationContent(this.award.nomination_fields[0][0])
        }
        else {
          this.$refs.isMonetary.checked = !this.$refs.isMonetary.checked
        }
      }
    },
    checkForDuplicateNominee: function(data) {
      var self = this
      if (data.employeehierarchy === false) {
        self.searchingForEmployeeError = 'Nominee ' + data.email + ' is not present in Think Tank list. For further assistance, Please contact thinktank@multichoice.co.za'
        return false
      }
      return true
    },
    setNominee: function () {
      this.searchingForEmployee = true
      this.searchingForEmployeeError = ''
      if (this.nominatedPerson.split(',').length > 50) {
        this.searchingForEmployee = false
        this.searchingForEmployeeError = 'Team Member count can\'t exceed 50!'
      }
      var self = this
      if (this.searchingForEmployee) {
        this.nominatedPerson.split(',').map(function (val, index) {
          val = val.trim().toLowerCase()
          if (val !== '') {
            if (val.indexOf('@') > -1) {
              ADauthentication.getUserInfoByEmail(val)
                .then(response => {
                  self.setValidatedNominee(response.data)
                  if (self.validatedNominee.name !== '') {
                    self.showNominationForm = true
                  }
                  self.searchingForEmployee = false
                })
                .catch(e => {
                  self.searchingForEmployee = false
                  self.searchingForEmployeeError = 'Unable to find the Nominee; Please try again!'
                  console.error(e)
                })
            } else {
              ADauthentication.getUserInfoByUsername(val.replace(' ', '.').toLowerCase())
                .then(response => {
                  self.setValidatedNominee(response.data)
                  if (self.validatedNominee.name !== '') {
                    self.showNominationForm = true
                  }
                  self.searchingForEmployee = false
                })
                .catch(e => {
                  self.searchingForEmployee = false
                  self.searchingForEmployeeError = 'We could not find a user with the names: ' + val + '. Make sure you entered the correct name and surname or try searching by email'
                  console.error(e)
                })
            }

          }
        })
      }
    },
    removeNominee: function () {
      this.validatedNominee = {name: '', department: '', employeeNum: ''}
      this.showNominationForm = false
      this.nominatedPerson = ''
      this.madeNomination = false
      this.NominationTeamNames = []
      this.submitClicked = true
    },
    setPostContent: function (type) {
      var content = ''
      var plainContent = ''
      for (var i = 0; i < this.nominationContent.length; i++) {
        if (this.nominationContent[i].displayField)
          if (this.nominationContent[i].label !== 'If applicable, please attach supporting documentation (Word, PowerPoint, video):' && this.nominationContent[i].label !== 'Project Sponsor Email' && this.nominationContent[i].label !== 'Choose Behaviour') {
            content += '<strong>' + this.nominationContent[i].label + '</strong><br><p>' + this.nominationContent[i].content + '</p>'
            plainContent += '<h>' + this.nominationContent[i].label + '<h> @#$% <c>' + this.nominationContent[i].content + '<c> @#$% '
          }
      }
      return (type === 'nohtml' ? plainContent : content)
    },
    ValidateFields: function (value, type, label) {
      if (type.toLowerCase() === 'email') {
        if (value.indexOf('@') === -1 || value.indexOf('.') === -1) {
          alert('Invalid ' + label + ' !')
          return false
        } else if (value.split('@').length > 2) {
          alert ('Only one mail allowed for ' + label + ' !' )
          return false
        }
        return true
      }
    },
    readyToSubmitNomination: function () {
      var contentPassedValidation = true
      this.searchingForEmployeeError = ''
      for (var j = 0; j < this.nominationContent.length; j++) {
        this.nominationFields[j].errorClass = ''
        if (this.nominationFields[j].display_field === false) {
          continue
        } else {
          if (this.nominationFields[j].validationMethod) {
            contentPassedValidation = this.ValidateFields(this.nominationContent[j].content, this.nominationFields[j].validationMethod, this.nominationContent[j].label)
          }
          if (this.nominationContent[j].required === 'false' && this.nominationContent[j].content === '' && !this.nominationContent[j].validated) {
            this.nominationContent[j].validated = true
          }
          if (this.nominationContent[j].validated === false) {
            contentPassedValidation = false
            this.nominationFields[j].errorClass = 'field-not-validated'
          }
          // Stop immedieatly any field validation is false
          if (contentPassedValidation === false)
            break;
        }
      }
      return contentPassedValidation
    },
    assignUserCommunities: function () {
      return this.award.community_categories.filter(
        f => this.$store.getters.getUserCommunityIDstring.split(',').map(x => parseInt(x)).includes(f)
      )
    },
    createNominationEntry: function () {
      this.showNominationForm = false
      this.creatingNomination = true
      var self = this
      var sendNomination = {
        method: 'POST',
        data: {
          title: self.validatedNominee.name + ', Employment Equity',
          nomination_event_category: self.award.nomination_event_category,
          community_categories: self.assignUserCommunities(),
          equity_nominee_name: self.validatedNominee.name,
          equity_employee_number: self.validatedNominee.employeeNum,
          equity_nominee_email: self.validatedNominee.emailToNotify,
          equity_nominator_employee_number: self.validatedNominee.employeeNum,
          equity_accept_reject: 'Pending',
          status: 'publish',
          content: self.setPostContent('html')
        },
        headers: {
          'Authorization': localStorage.getItem('userToken'),
          'Content-Type': 'application/json'
        },
        json: true
      }

      WordpressRestAPI.endpointWithAuthetication(sendNomination, 'employment_equity')
        .then(function (response) {
          console.log(response)
          // Emails notification goes here
          self.sendNotificationforNomination(response.data)
          self.madeNomination = true
          self.creatingNomination = false
        })
        .catch(function (e) {
          self.createNominationError = 'Oops! We had a problem adding your nomination. Please try again later.'
          console.error(e)
        })
    },
    sendNotificationforNomination: function (nominationDetails) {
      let emailBody = ''
      var tempEmail = []
      if (nominationDetails.id) {
        emailBody = NominationNotification.equitynominationBodyforNominee({
          reviewLink: WordpressRestURI.frontEndDomain + 'login/equity-review+' + nominationDetails.id,
        })
        var emailNominationNotification = {
          method: 'POST',
          data: {
            to: nominationDetails.equity_nominee_email[0],
            subject: 'Your Nomination as Employment Equity Forum Representative',
            message: emailBody
          },
          json: true
        }
        WordpressRestAPI.sendEmail(emailNominationNotification)
          .then(function (response) {
            console.log(response.data)
          })
          .catch(function (e) {
            console.error(e)
          })
      }
    },
    submitNomination: function () {
      this.submitClicked = false
      if (this.readyToSubmitNomination()) {
        this.createNominationEntry()
      } else {
        this.submitClicked = true
      }
    },
    fieldUpdated: function (fieldDetails) {
      for (var i = 0; i < this.nominationContent.length; i++) {
        if (this.nominationContent[i].label === fieldDetails.label) {
          this.nominationContent[i].content = fieldDetails.content
          this.nominationContent[i].validated = fieldDetails.validated
          this.nominationContent[i].displayField = fieldDetails.displayField
          if (fieldDetails.label === 'Choose Behaviour') {
            this.nominationContent[i].parentcategory = fieldDetails.parentcategory
            this.nominationContent[i].parentName = fieldDetails.parentName
          }
          break
        }
      }
    },
    setNominationContent: function (nominationFields) {
      var self = this
      self.nominationFields = nominationFields.map(function (x, index) {
        var displayFieldVal = x.display_field === "No" ? false : true
        var fieldDescriptionVal = x.field_description
        var FieldSecondaryDescriptionVal = x.field_secondary_description

        return {
          type: x.form_field_type,
          description: fieldDescriptionVal,
          secondaryDescription: FieldSecondaryDescriptionVal,
          isRequired: x.required_nomination_field,
          checkboxLabels: x.checkbox_labels,
          errorClass: '',
          index: index + x.form_field_type,
          description_lvl_two: x.description_lvl_two,
          secondary_description_lvl_two: x.secondary_description_lvl_two,
          display_field: displayFieldVal,
          validationMethod: x.validationmethod
        }
      })

      if (self.nominationContent.length > 1) {
        self.nominationContent = self.nominationFields.map(function (x, i) {
          return {label: x.description, content: self.nominationContent[i].content, required: x.isRequired, validated: false, displayField: x.displayField}
        })
      } else  {
        self.nominationContent = self.nominationFields.map(function (x) {
          return {label: x.description, content: '', required: x.isRequired, validated: false, displayField: x.displayField}
        })
      }
    },
    loadContent: function () {
      this.madeNomination = false
      this.nominatedPerson = ''
      document.title = this.$route.name + ' - ThinkTank'
      WordpressRestAPI.getViewContent('nomination_event?nomination_event_category=136&_embed&per_page=1')
        .then(response => {
          this.award = response.data[0]
          console.log('response', this.award)
          this.contentReady = true
          if (this.award.include_nomination_form[0] === 'Yes') {
            this.NominationButtonText = 'Add Nominee'
            this.NominationPlaceholder = 'Search by email address, seperate multiple email by comma...'
            this.validatedNominee = ''
            this.setNominationContent(this.award.nomination_fields[0][0])
          }
        })
        .catch(e => {
          this.contentLoadError = 'Oops! We had a problem with loading this Recognition. Please try again later.'
          console.error(e)
          this.contentReady = true
        })
    },
    searchNomineeList: function (newQuery) {
      if ( newQuery.length > 2 )
      WordpressRestAPI.getCustomViewContent('getNominees/v1/nomineelist?search=' + newQuery)
        .then((res) => {
          this.nomineesList = res.data
        })
    }
  },
  created () {
    this.loadContent()
  },
  watch: {
    nominatedPerson (newQuery, oldQuery) { 
      if (newQuery != '')
        this.searchNomineeList(newQuery) 
    },
    '$route' (to, from) {
      this.contentReady = false
      this.loadContent()
    }
  }
}
</script>

<style lang="less">
  .featuredImg {
    img {
      width: 100%;
    }
  }
  .box {.icon { text-align: center; position: relative; }}
  .box { .icon { .image { position: relative; z-index: 2; width: 50px; height: 50px; line-height: 50px; border-radius: 50%; background: #09ced6; vertical-align: middle; }}}
  .box { .icon:hover { .image { background: #63B76C; }}}
  .box { .icon { .image { i { color: #fff !important; border: 1px solid white; padding: 10px; border-radius: 50%; min-width: 38px;}}}}
  .box { .icon { .info { margin-top: -45px; margin-left: 20px; padding: 15px 20px 10px 0px; }}}
  .box { .icon { .infoaqua { background-color:#CEF6F8; }}}
  .box { .icon { .infogrey { background-color:#F8F8F8; }}}
  .box { .icon { .infowhite { background-color:#FFFFFF; }}}
  .box { .icon { .info { h3 { font-weight: 500;  margin: 0 0 0 50px; text-align: left; color: #09ced6; }}}}
  .box { .icon { .info { h5 { font-weight: 500;  margin: 0 0 0 50px; text-align: left; color: #09ced6; }}}}
  .box { .icon { .info { ul {list-style: none; margin-left: 20px;}}}}
  .box { .icon { .info { ul { li::before { content: "\2022"; color: #09ced6; display: inline-block; width: 1em; margin-left: -1em;}}}}}
  .box { .icon { .info { .miniseparator {width: 55px; border-bottom: 5px solid #09ced6; margin-left: 50px;}}}}
  .box { .icon { .info { p {margin-left: 40px;}}}}
  .aquacolor {color:#09ced6;}
  .navycolor {color: navy;}
</style>



// WEBPACK FOOTER //
// src/components/routes/EMEquity.vue